import React, { MutableRefObject } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import BgLogo from "../../../components/BgLogo";
import TransitionComp from "../../../components/TransitionComp";
import "../../../styles/SingleProject.css";
import { animateSingleProject } from "../helperAnimations";

import img1 from "../../../images/portfolio1/img-proj1.jpg";
import img2 from "../../../images/portfolio1/img-proj1b.jpg";
import anime from "animejs";
import SingleProjectModal from "../../../components/SingleProjectModal";
import { totalObjects } from "../../../data/projects";
import { ArrowForward } from "react-ionicons";
function SingleProject() {
  let params = useParams();
  console.log(params);
  const navigate = useNavigate()
  const projecturl = totalObjects.find((project) => project.projectUrl === params.id);

  if (!projecturl){
    navigate("/")
  }

  const getNextProjectPage = (): string => {
    
    switch (params.id) {
      case "project4":
       return "/portfolio/project1"
       case "project3":
        return "/portfolio/project4"
        case "project1":
          return "/portfolio/project2"
          case "project2":
           return "/portfolio/project3"
      default:
        return "" 
    } 
  }
  const letterRef = React.useRef() as MutableRefObject<HTMLDivElement>;
  React.useEffect(() => {
    var textWrapper = letterRef.current;
    if (typeof textWrapper.textContent === "string") {
      textWrapper.innerHTML =
        textWrapper.textContent &&
        textWrapper.textContent.replace(
          /\S/g,
          "<span class='project_letter'>$&</span>"
        );
      // Wrap every letter in a span
      anime.timeline().add({
        targets: ".ml12 .project_letter",
        translateY: [200, 0],
        translateZ: 0,
        opacity: [0, 1],
        easing: "easeOutExpo",
        duration: 2000,
        delay: (el, i) => 2000 + 60 * i,
      });
    }

    animateSingleProject(`.single_project_left_${params.id}`);
  }, []);

  const [openModal, setOpenModal] = React.useState(false)
  return (
    <>
      <TransitionComp children={<BgLogo />} />
     {openModal && <SingleProjectModal />}
      <div className="single_project_container">
        <div className={`single_project_left_${params.id} single_project_column`}>
        
        </div>
        <div className="single_project_right single_project_column">
          <div className="images">
            <div className={`${params.id}-img-1 single_project_right_img`}></div>
            <div className={`${params.id}-img-2 single_project_right_img`}></div>
            <div className={`${params.id}-img-3 single_project_right_img`}></div>
            <div className={`${params.id}-img-4 single_project_right_img`}></div>
          </div> 
          {/* <p className="project_text">
          better than brand new second hand clothing / focus by sick apparel
              everyday,<br></br>
              <a href="/" target="__blank">View Demo</a>
          </p> */}
            <div className="single_project_header">
           
            <p>
            {projecturl?.text1}
            </p>
             <div  className="linksDemoDiv">
             <a href={projecturl?.projectHref} target="__blank" style={{color: "#6adb9d"}}>View Demo</a>

           <Link  to={getNextProjectPage()} className="nextPageDiv">
           <ArrowForward  color={"#6adb9d"} 
                  width="40px"
                  onClick={() => alert("Hi!")}
                  title={"Options"} />
            <p className="nextPageLink">
              Next Project
            </p>
            <div className="growingLineDiv" />
           </Link>
             </div>
          </div>
  
          <div>
            <h1 className="ml12" ref={letterRef}>
              {projecturl?.title}
            </h1>
          </div>
        </div>
      </div>
    </>
  );
}

export default SingleProject;
